<template>
  <div id="app">
    <ue-header />
    <router-view v-if="bannerList"  class="container ue-body" />
    <ue-footer />
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import UeHeader from '@/components/common/Header.vue'
import UeFooter from '@/components/common/Footer.vue'
export default {
  components: { UeHeader,UeFooter },
  methods: {
    ...mapActions('home', ['initApp']),
    ...mapGetters('home', ['bannerList'])
  },
  async created () {
    await this.initApp()
  }
}
</script>

<style lang="scss">
#app {
  font-family: MicrosoftYaHei, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 13px;
  // padding-bottom: 60px;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.ue-body {
  padding-top: 96px !important;
}
@media screen and (max-width: 1000px) {
  .container {
    width: 100% !important;
  }
}
</style>
